import React, { useState, useEffect } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import "./faqs.css";
import AOS from "aos";
import "aos/dist/aos.css";

const FAQsSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
    });
    // AOS.refresh();
  }, []);

  const faqData = [
    {
      question: "O que faz exatamente a Guestza?",
      answer:
        "Gerimos todos os aspetos do seu alojamento de curta duração — desde o marketing e definição de preços, até à comunicação com os hóspedes, limpeza e manutenção — para que possa ganhar mais, sem complicações.",
      isOpenByDefault: false,
    },
    {
      question: "Quais são os custos do serviço?",
      answer:
        "Os nossos custos são uma percentagem das receitas geradas por cada reserva. A taxa varia com base no plano que escolher. Contacte-nos para mais detalhes.",
      isOpenByDefault: false,
    },
    {
      question: "Continuo com controlo sobre o meu alojamento?",
      answer:
        "Sim, absolutamente. Mantém o controlo total sobre o seu alojamento. Pode bloquear datas para uso pessoal e temos um gestor de conta pessoal para garantir que as suas preferências são sempre respeitadas.",
      isOpenByDefault: false,
    },
    {
      question: "Que tipo de propriedades gerem?",
      answer:
        "Gerimos uma vasta gama de propriedades, desde apartamentos a moradias, em diversas localizações. Se a sua propriedade for adequada para aluguer de curta duração, podemos ajudá-lo.",
      isOpenByDefault: false,
    },
    {
      question: "Como melhoram a experiência dos hóspedes?",
      answer:
        "Garantimos uma comunicação rápida e eficiente, um processo de check-in e check-out simples, e propriedades limpas e bem mantidas. Também oferecemos amenidades premium e assistência 24/7 para os hóspedes.",
      isOpenByDefault: false,
    },
  ];

  const [openIndex, setOpenIndex] = useState(
    faqData.findIndex((item) => item.isOpenByDefault)
  );

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faqs" className="faq-section">
      <div className="faq-container">
        <div className="faq-header">
          <div className="faq-starter">
            <span data-aos="fade-up" data-aos-delay="100" className="faq-subtitle">FAQ's</span>
          </div>

          <h1 className="faq-title">
            <span data-aos="fade-up" data-aos-delay="100" className="aos-blur">Perguntas</span><br />
            <span data-aos="fade-up" data-aos-delay="100" className="aos-blur-bg">Frequentes</span>
          </h1>

          <p className="faq-description">
            <span>Respostas rápidas às questões mais frequentes. Se</span>
            <span>não encontrares o que procuras, entra em contacto.</span>
          </p>
        </div>
        <div className="faq-list-container">
          <div className="faq-list">
            {faqData.map((item, index) => (
              <div key={index} className="faq-item" data-aos="fade-up"
                data-aos-delay={index * 150}>
                <button onClick={() => toggleFAQ(index)} className="faq-question">
                  <h6 className="question-text">{item.question}</h6>
                  {openIndex === index ? (
                    <ChevronUp className="icon" />
                  ) : (
                    <ChevronDown className="icon" />
                  )}
                </button>
                <div
                  className={`faq-answer ${openIndex === index ? "open" : ""}`}
                >
                  <p>{item.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQsSection;